import { render, staticRenderFns } from "./SiteNavDesktopShopMenu.vue?vue&type=template&id=0f0bee8e&scoped=true&lang=pug"
import script from "./SiteNavDesktopShopMenu.vue?vue&type=script&lang=js"
export * from "./SiteNavDesktopShopMenu.vue?vue&type=script&lang=js"
import style0 from "./SiteNavDesktopShopMenu.vue?vue&type=style&index=0&id=0f0bee8e&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0bee8e",
  null
  
)

export default component.exports